import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Removes "name" to allow radios with same name to be used
const Radio = ({ children, className, name, ariaLabel, ...props }) => {
  function handleChange(e) {
    e.target.name = name

    if (props.onChange) {
      props.onChange(e)
    }

    if (props.onClick) {
      props.onClick(e)
    }
  }

  return (
    <div className={className}>
      <input
        type="radio"
        id="radio"
        {...props}
        onChange={handleChange}
        onClick={handleChange}
        aria-label={ariaLabel || name}
      />
      {!!children && <StyledLabel>{children}</StyledLabel>}
    </div>
  )
}

Radio.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  label: PropTypes.string
}

const StyledLabel = styled.label`
  padding-left: 5px;
`

export default Radio
